export type Route =
  | { page: "home" }
  | { page: "learn"; slug: string }
  | { page: "graph" }
  | { page: "suggestions" }
  | { page: "study"; slug: string }
  | { page: "not-found" };

export function currentRoute(pathname = window.location.pathname): Route {
  if (pathname === "/") return { page: "home" };
  if (pathname === "/graph") return { page: "graph" };
  if (pathname === "/suggestions" || pathname === "/suggestions/") return { page: "suggestions" };
  const learn = pathname.match(/^\/learn\/([a-z0-9-]+)\/?$/);
  if (learn) return { page: "learn", slug: learn[1] };
  const study = pathname.match(/^\/studies\/([a-z0-9-]+)\/?$/);
  if (study) return { page: "study", slug: study[1] };
  return { page: "not-found" };
}

export function navigate(href: string): void {
  history.pushState({}, "", href);
  window.dispatchEvent(new PopStateEvent("popstate"));
  window.scrollTo({ top: 0, behavior: "instant" });
}

export function installLinkNavigation(): () => void {
  const listener = (event: MouseEvent) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = event.composedPath().find((node) => node instanceof HTMLAnchorElement) as HTMLAnchorElement | undefined;
    if (!target || target.origin !== window.location.origin || target.target) return;
    event.preventDefault();
    navigate(`${target.pathname}${target.search}${target.hash}`);
  };
  document.addEventListener("click", listener);
  return () => document.removeEventListener("click", listener);
}
